import { createModel } from '@rematch/core';
import { RootModel } from '.';

const UtilNamesArr = [
  'header',
  'footer',
] as const;
type UtilNames = typeof UtilNamesArr[number];

type Dimentions = {
  height: number
};

const defaultDimentions: Dimentions = {
  height: 0,
};

export type Util = Record<UtilNames, Dimentions>

const defaultUtilState = UtilNamesArr.reduce((prev, current) => ({
  ...prev,
  [current]: defaultDimentions,
}) as Util, {});

const utilModel = createModel<RootModel>()({
  state: defaultUtilState as Util,
  reducers: {
    SET_HEIGHT(state: Util, type: UtilNames, height: number) {
      return {
        ...state,
        [type]: {
          height,
        },
      };
    },
  },
});

export default utilModel;
